export const getNameInitials = name => {
  return name ? name.charAt(0).toUpperCase() : '';
};
